import { merge } from 'lodash';
import { sortOptionsInOfferById } from '../../lib/sort-options';
import { computeOfferPrice } from './lib/computeOfferPrice';

export type InitialStateType = {|
  changePlanDate: string,
  plan: Object,
  options: Object[],
  price: number,
|};

const initialState: InitialStateType = {
  changePlanDate: 'now',
  plan: null,
  options: [],
  price: 0,
};

export const newOfferReducer = (state: InitialStateType = initialState, action) => {
  let newState;
  switch (action.type) {
    case 'SET_NEW_OFFER':
      return action.payload.offer;
    case 'REMOVE_UNAVAILABLE_OFFER': {
      newState = merge({}, state);

      if (action.availableOption) {
        const selectedOptions = newState.options;
        const validOptions = action.availableOption;

        newState.options = selectedOptions.filter(
          option => option.type !== 'DEFAULT' || validOptions.some(validOption => validOption.ouid === option.ouid)
        );
      }

      newState.price = computeOfferPrice(newState);

      return sortOptionsInOfferById(newState);
    }
    case 'ADD_OPTION_TO_NEW_OFFER': {
      const { newOption, optionToRemove } = action;
      newState = merge({}, state);
      //if there is an old option or ended promotion in the state, we have to identify and remove it manually
      const unavailableOptionToRemove = newOption
        ? newState.options.find(option => option.type === newOption.type)
        : undefined;

      if (unavailableOptionToRemove) {
        newState.options = newState.options.filter(option => option.type !== unavailableOptionToRemove.type);
      }

      if (optionToRemove) {
        newState.options = newState.options.filter(option => option.ouid !== optionToRemove.ouid);
      }
      if (newOption) {
        newState.options = [...newState.options, newOption];
      }

      newState.price = computeOfferPrice(newState);

      return sortOptionsInOfferById(newState);
    }
    default:
      return state;
  }
};
